import React from 'react';
import { CareGiver, CaregiverWithAssignedFamilyData } from '../../../types/caregivers';
import { Checkbox, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, Tooltip } from '@nextui-org/react';
import { CARE_GIVERS_TABLE_COLS } from '../../../constants/tables';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ArticleIcon from '@mui/icons-material/Article';
import { ts2Age } from '../../../helpers/utils';
import theme from '../../theme';
import GroupRemoveRoundedIcon from '@mui/icons-material/GroupRemoveRounded';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface IcareGiversTable {
  className?: string;
  data: CaregiverWithAssignedFamilyData[];
  onDelete: (caregiver: CareGiver) => void;
  onEdit: (caregiver: CareGiver) => void;
  onFamilyRemove: (caregiver: CareGiver) => void;
  onWarningToggle: (c_id: string, value: boolean) => void;
}

export default function CareGiversTable({
  data,
  className,
  onDelete,
  onFamilyRemove,
  onWarningToggle,
  onEdit,
}: IcareGiversTable) {

  return (
    <Table
      removeWrapper
      className={className} 
      isStriped aria-label="Famiglie">
      <TableHeader>
        {CARE_GIVERS_TABLE_COLS.map((c, i) => (
          <TableColumn key={i} style={i === 0 ? {width: theme.sizing.x8, textAlign: 'center'} : undefined}>{c}</TableColumn>
        ))}
      </TableHeader>
      <TableBody>
        {
          data.map((caregiver, i) => (
            <TableRow key={i}>
               <TableCell>
                <div style={{justifyContent: 'center', alignItems: 'center'}}>
                {
                  caregiver.warning && (
                    <Tooltip content='Attenzione'>
                      <WarningAmberIcon style={{color: 'orange'}}/>
                    </Tooltip>
                  )
                }
                </div>
                
              </TableCell>
              <TableCell>{caregiver.personalData.surname}</TableCell>
              <TableCell>{caregiver.personalData.name}</TableCell>
              <TableCell>{ts2Age(caregiver.personalData.tsDateOfBirth)}</TableCell>
              <TableCell>{caregiver.personalData.address}</TableCell>
              <TableCell>{caregiver.assingedFamilyData ? `${caregiver.assingedFamilyData.name} ${caregiver.assingedFamilyData.surname}`: 'Nessuna'}</TableCell>
              <TableCell className='max-w-20'>
                <div className="items-center">
                  <Tooltip content="Vedi">
                    <span
                      onClick={() => onEdit(caregiver)} 
                      className="text-lg text-default-400 cursor-pointer active:opacity-50 mr-4">
                      <RemoveRedEyeIcon style={{color: theme.color.primary}}/>
                    </span>
                  </Tooltip>
                  <Tooltip color="danger" content="Rimuovi badante">
                    <span
                      onClick={() => onDelete(caregiver)} 
                      className="text-lg text-danger cursor-pointer active:opacity-50 mr-4">
                      <DeleteIcon />
                    </span>
                  </Tooltip>
                  {
                    caregiver.assignedTo && (
                      <Tooltip color="danger" content="Elimina">
                        <span
                          onClick={() => onFamilyRemove(caregiver)} 
                          className="text-lg text-danger cursor-pointer active:opacity-50 mr-4">
                          <GroupRemoveRoundedIcon />
                        </span>
                      </Tooltip>
                    )
                  }
                  <Tooltip content="Contrassegna">
                    <span>
                      <Checkbox
                        isSelected={caregiver.warning ?? false}
                        onValueChange={(v) => onWarningToggle(caregiver.id, v)}/>
                    </span>
                  </Tooltip>
                </div>
              </TableCell>
            </TableRow>
          ))
        }
      </TableBody>
    </Table>
  )
}